export const createRandomBoolean = () => {
  const random1 = Math.random();
  const random2 = Math.random();

  return random1 > random2;
};
